// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ERph2","select":"styles_select__3sjt3"};